// ログイン (オンボーディング) 画面。Zoom OAuth 開始リンクを表示するだけのシンプル UI。
// spec §8 オンボーディングフローの最初のステップに対応。

import { type ReactElement } from 'react';
import { t, type Locale } from '@solo-webinar-copilot/i18n';
import { loginUrl } from './lib/api.ts';

export function Login({ locale }: { locale: Locale }): ReactElement {
  return (
    <main data-testid="login">
      <h1>{t('web.login.title', locale)}</h1>
      <p>{t('web.login.body', locale)}</p>
      <a href={loginUrl()} data-testid="login-zoom-button">
        {t('web.login.zoom', locale)}
      </a>
    </main>
  );
}
